import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  }
};

const enhance = compose();

const UserTableHead = enhance(({ order, orderBy, onRequestSort }) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell />
        <TableCell sortDirection={orderBy === 'gochiEventId' ? order : false}>
          <TableSortLabel
            active={orderBy === 'gochiEventId'}
            direction={order}
            onClick={() => {
              onRequestSort('gochiEventId');
            }}
          >
            イベントID
          </TableSortLabel>
        </TableCell>
        <TableCell>優先度</TableCell>
        <TableCell sortDirection={orderBy === 'gochiEventName' ? order : false}>
          <TableSortLabel
            active={orderBy === 'gochiEventName'}
            direction={order}
            onClick={() => {
              onRequestSort('gochiEventName');
            }}
          >
            イベント名
          </TableSortLabel>
        </TableCell>
        <TableCell>イベント種別</TableCell>
        <TableCell>対象グループ</TableCell>
        <TableCell sortDirection={orderBy === 'startDate' ? order : false}>
          <TableSortLabel
            active={orderBy === 'startDate'}
            direction={order}
            onClick={() => {
              onRequestSort('startDate');
            }}
          >
            公開時間
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'endDate' ? order : false}>
          <TableSortLabel
            active={orderBy === 'endDate'}
            direction={order}
            onClick={() => {
              onRequestSort('endDate');
            }}
          >
            終了時間
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'eventFeeRate' ? order : false}>
          <TableSortLabel
            active={orderBy === 'eventFeeRate'}
            direction={order}
            onClick={() => {
              onRequestSort('eventFeeRate');
            }}
          >
            手数料負担率
          </TableSortLabel>
        </TableCell>
        <TableCell
          sortDirection={orderBy === 'supportPricePercentRate' ? order : false}
        >
          <TableSortLabel
            active={orderBy === 'supportPricePercentRate'}
            direction={order}
            onClick={() => {
              onRequestSort('supportPricePercentRate');
            }}
          >
            プレミアム分
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'maxTotalAmount' ? order : false}>
          <TableSortLabel
            active={orderBy === 'maxTotalAmount'}
            direction={order}
            onClick={() => {
              onRequestSort('maxTotalAmount');
            }}
          >
            拠出予算額
          </TableSortLabel>
        </TableCell>
        <TableCell
          sortDirection={orderBy === 'maxTotalAmountPerOrder' ? order : false}
        >
          <TableSortLabel
            active={orderBy === 'maxTotalAmountPerOrder'}
            direction={order}
            onClick={() => {
              onRequestSort('maxTotalAmountPerOrder');
            }}
          >
            一回あたりの購入上限額
          </TableSortLabel>
        </TableCell>
        <TableCell
          sortDirection={orderBy === 'maxTotalAmountShop' ? order : false}
        >
          <TableSortLabel
            active={orderBy === 'maxTotalAmountShop'}
            direction={order}
            onClick={() => {
              onRequestSort('maxTotalAmountShop');
            }}
          >
            1店舗あたりの購入上限額
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'shopFeeRate' ? order : false}>
          <TableSortLabel
            active={orderBy === 'shopFeeRate'}
            direction={order}
            onClick={() => {
              onRequestSort('shopFeeRate');
            }}
          >
            店舗が負担する手数料率
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'gochiStartDate' ? order : false}>
          <TableSortLabel
            active={orderBy === 'gochiStartDate'}
            direction={order}
            onClick={() => {
              onRequestSort('gochiStartDate');
            }}
          >
            利用開始日
          </TableSortLabel>
        </TableCell>
        <TableCell
          sortDirection={orderBy === 'gochiExpriedDate' ? order : false}
        >
          <TableSortLabel
            active={orderBy === 'gochiExpriedDate'}
            direction={order}
            onClick={() => {
              onRequestSort('gochiExpriedDate');
            }}
          >
            利用期限
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'createdAt' ? order : false}>
          <TableSortLabel
            active={orderBy === 'createdAt'}
            direction={order}
            onClick={() => {
              onRequestSort('createdAt');
            }}
          >
            作成時間
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'updatedAt' ? order : false}>
          <TableSortLabel
            active={orderBy === 'updatedAt'}
            direction={order}
            onClick={() => {
              onRequestSort('updatedAt');
            }}
          >
            更新時間
          </TableSortLabel>
        </TableCell>
        <TableCell />
        <TableCell />
      </TableRow>
    </TableHead>
  );
});

export default withStyles(styles)(UserTableHead);
